export const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasNonalphas = /\W/.test(password);
  
  if (password.length < minLength) return "La contraseña debe tener al menos 8 caracteres.";
  if (!hasUpperCase) return "La contraseña debe tener al menos una mayúscula.";
  if (!hasLowerCase) return "La contraseña debe tener al menos una minúscula.";
  if (!hasNumbers) return "La contraseña debe tener al menos un número.";
  if (!hasNonalphas) return "La contraseña debe tener al menos un símbolo (!@#$...).";
  
  return null;
};

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase()) ? null : "El correo electrónico no es válido.";
};